import React, { useState } from "react";
import { Badge, Modal } from "@frontrunners/ui-components";
import CustomButton from "../../../../common/CustomButton";
import { SSCIAM_ACCESS_TOKEN_KEY } from "../../../../common/authHelper";

export const ResetUserPhoneNumberModal = ({ user, endpoints, onClose }) => {
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleResetPhoneNumber = async () => {
    setIsLoading(true);
    setError(false);
    try {
      const accessToken = window.localStorage.getItem(SSCIAM_ACCESS_TOKEN_KEY);
      const url = `${endpoints.sscIamUserMgtApi}/admin/operations/users/${user.email}/credentials/otp/sms/reset`;
      const options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          reason: "User requested OTP reset",
        }),
      };
      const response = await fetch(url, options);
      const res = await response.json();
      if (response.status !== 200) {
        setError({ reason: res.error.message });
      } else {
        setError(false);
        onClose();
      }
    } catch (err) {
      setError({ reason: "Failed to reset phone number" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      onClose={() => {
        setError(false);
        onClose();
      }}
    >
      <h1 style={{ marginTop: 20 }}>
        This will reset the phone number for the <Badge className="warning">{user.email}</Badge> user
      </h1>
      <p>
        This will reset the curent phone number. At the next login the user will have to re-register with a new phone
        number.
      </p>
      <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
        <CustomButton variant="default" onClick={handleResetPhoneNumber} loading={isLoading}>
          Yes, reset number
        </CustomButton>
        <CustomButton
          variant="text"
          onClick={() => {
            setError(false);
            onClose();
          }}
          disabled={isLoading}
        >
          Cancel
        </CustomButton>
      </div>
      {error && error.reason && <div className="error">{error.reason}</div>}
    </Modal>
  );
};
